import { render, staticRenderFns } from "./BasketPresentation-gt3.vue?vue&type=template&id=a2059c74&scoped=true"
import script from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
export * from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
import style0 from "./BasketPresentation-gt3.vue?vue&type=style&index=0&id=a2059c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2059c74",
  null
  
)

export default component.exports